import _ from 'lodash';

export const isDefined = <T>(val: T | undefined | null): val is T => !_.isNil(val);
